import type { MessageDescriptor } from 'react-intl';

import { UpsellModalContentCodes } from '../../constants/upsell-modal-content-codes';

import type { UpsellModalContentCode } from '../../constants/upsell-modal-content-codes';

/** Available sources where the upsell banner can appear */
export const BannerSources = {
  Products: 'products',
  Returns: 'returns',
  Analytics: 'analytics',
  Todo: 'todo',
} as const;

export type BannerSource = (typeof BannerSources)[keyof typeof BannerSources];

/** Maps banner sources to their corresponding upsell modal content codes */
export const BannerSourceToFeatureCode: Record<BannerSource, UpsellModalContentCode> = {
  [BannerSources.Products]: UpsellModalContentCodes.ProductCatalog as UpsellModalContentCode,
  [BannerSources.Returns]: UpsellModalContentCodes.EnhancedReturns as UpsellModalContentCode,
  [BannerSources.Analytics]: UpsellModalContentCodes.DashboardsViewOnly as UpsellModalContentCode,
  [BannerSources.Todo]: UpsellModalContentCodes.PremiumTrial as UpsellModalContentCode,
};

/** Available tiers of plan features a user can trial */
export const TrialTiers = {
  Standard: 'standard',
  Premium: 'premium',
} as const;

export type TrialTier = (typeof TrialTiers)[keyof typeof TrialTiers];

/** Maps trial tiers to their corresponding billing plan codes */
export const TriableBillingPlanTiersToPlanCodes: Record<TrialTier, string> = {
  [TrialTiers.Standard]: 'standard_2025q2',
  [TrialTiers.Premium]: 'premium_2025q2',
};

/** Trial history object - keys are billing plan codes, values contain trial metadata */
export type PlanFeaturesTrialHistory = Record<string, unknown>;

/** Content structure for banner messages */
export type BannerContent = {
  titleMessage: MessageDescriptor;
  subheaderMessage: MessageDescriptor;
};
